import styles from "./index.module.less";
import HomeP1Mask from "@/assets/imgs/home/p1_mask.png";
import HomeP2Mask from "@/assets/imgs/home/p2_mask.png";
import { useEffect, useRef } from "react";
import AnimateBox from "@/components/AnimateBox";
import p1TextTitle from "@/assets/imgs/home/p1_text_title.png";
import ProductList from "./components/ProductList";
import HumanList from "./components/HumanList";
import CaseList from "./components/CaseList";
import Lottie from "lottie-react";
import jiantouOrange from "@/assets/lottie/jiantou_orange.json";
import FocusList from "./components/FocusList";
import PartnerList from "./components/PartnerList";
import logo1 from "./imgs/logo1.png";
import logo2 from "./imgs/logo2.png";
import logo3 from "./imgs/logo3.png";
import logo4 from "./imgs/logo4.png";
import { Flex } from "antd";
import useHoverLottie from "@/hooks/useHoverLottie";
import data from "./data.json";
import { useNavigate } from "react-router-dom";
import { isMobile } from "@/utils";
import MobileHome from "./mobile";

const Home = () => {
  const scrollXRef = useRef<any>();
  const handleMouseMove = (e: React.MouseEvent) => {
    if (!scrollXRef.current) return;
    const deltaX = e.movementX;
    scrollXRef.current.scrollLeft -= deltaX;
  };
  const handleMouseDown = (e: React.MouseEvent) => {
    if (!scrollXRef.current) return;
    scrollXRef.current.addEventListener("mousemove", handleMouseMove, {
      passive: true,
    });
    scrollXRef.current.style.cursor = "grabbing";
  };
  const handleMouseUp = (e: React.MouseEvent) => {
    if (!scrollXRef.current) return;
    scrollXRef.current.removeEventListener("mousemove", handleMouseMove);
  };

  const scrollLogoRef = useRef<HTMLDivElement>(null);
  const scrollLogoRef1 = useRef<HTMLDivElement>(null);
  const scrollLogoRef2 = useRef<HTMLDivElement>(null);
  const scrollLogoRef3 = useRef<HTMLDivElement>(null);
  const p1Mask = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // 合作商滚动条
    window.gsap.to(scrollLogoRef.current, {
      x: "-50%",
      duration: 150,
      ease: "linear",
      repeat: -1,
    });
    window.gsap.set(scrollLogoRef1.current, {
      x: "-50%",
    });
    window.gsap.to(scrollLogoRef1.current, {
      x: "0%",
      duration: 150,
      ease: "linear",
      repeat: -1,
    });
    window.gsap.to(scrollLogoRef2.current, {
      x: "-50%",
      duration: 150,
      ease: "linear",
      repeat: -1,
    });
    window.gsap.set(scrollLogoRef3.current, {
      x: "-50%",
    });
    window.gsap.to(scrollLogoRef3.current, {
      x: "0%",
      duration: 150,
      ease: "linear",
      repeat: -1,
    });
    // 第一屏左侧遮罩
    window.gsap.set(p1Mask.current, {
      x: "-100%",
      opacity: 0,
    });
    // 第一屏左侧遮罩动画
    window.gsap.to(p1Mask.current, {
      x: "0%",
      opacity: 1,
      duration: 1,
    });
    window.gsap.from(`.${styles.p1_text} *`, {
      y: 50,
      opacity: 0,
      duration: 0.5,
      delay: 0.5,
      stagger: 0.1,
    });

    window.gsap.to(`.${styles.video_box}`, {
      opacity: 1,
      duration: 1,
    });
    // 解决ios微信无法自动播放的问题
    function doPlay() {
      window.WeixinJSBridge.invoke("getNetworkType", {}, function () {
        (document.querySelector(`.${styles.video_box} video`) as any)?.play();
      });
    }

    if (window.WeixinJSBridge) {
      doPlay();
    } else {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          doPlay();
        },
        false
      );
    }
  }, []);
  const {
    lottieOptions: lottieOptions1,
    playLottieOnce: playLottieOnce1,
    stopLottie: stopLottie1,
  } = useHoverLottie({
    animationData: jiantouOrange,
  });
  const {
    lottieOptions: lottieOptions2,
    playLottieOnce: playLottieOnce2,
    stopLottie: stopLottie2,
  } = useHoverLottie({
    animationData: jiantouOrange,
  });
  const {
    lottieOptions: lottieOptions3,
    playLottieOnce: playLottieOnce3,
    stopLottie: stopLottie3,
  } = useHoverLottie({
    animationData: jiantouOrange,
  });
  const navigate = useNavigate();
  return (
    <div className={styles.home}>
      <div className={styles.p1}>
        <div className={styles.video_box}>
          <video
            src="https://virtualhuman-app.oss-cn-beijing.aliyuncs.com/interaction/public/official_website/home.mp4"
            autoPlay
            muted
            loop
            playsInline
            // poster={p1Poster}
          />
        </div>
        <div ref={p1Mask} className={styles.p1_mask}>
          <img src={HomeP1Mask} />
        </div>
        <div className={styles.p1_text}>
          <img src={p1TextTitle} />
          <div className={styles.p1_text_box}>
            <div>{data.p1.title}</div>
            <div>{data.p1.subtitle}</div>
          </div>
        </div>
      </div>
      <div className={styles.p2}>
        {/* 产品卡片列表 */}
        <div className={styles.p2_product_list}>
          <ProductList />
        </div>
        <AnimateBox
          classNameIn="fadeInRight"
          classNameOut="fadeOutRight"
          className={styles.p2_mask}
        >
          <img src={HomeP2Mask} />
        </AnimateBox>
      </div>
      <div className={styles.p4}>
        <div className={styles.p4_inner}>
          <div className={styles.p4_title}>
            <div className={styles.p4_title_text}>行业案例</div>
            <Flex
              align="center"
              gap={8}
              className={styles.p4_more}
              onClick={() => {
                navigate("/solutions");
              }}
              onMouseEnter={playLottieOnce3}
              onMouseLeave={stopLottie3}
            >
              MORE
              <Lottie {...lottieOptions3} />
            </Flex>
          </div>
          <div className={styles.p4_case_list}>
            <CaseList />
          </div>
        </div>
      </div>
      <div className={styles.p4_logo_text}>
        <span>更多客户</span>由小冰科技赋能AI实践
      </div>
      <div
        className={styles.p4_scroll_box}
        ref={scrollXRef}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
      >
        <Flex
          align="center"
          className={styles.p4_scroll_box_inner}
          ref={scrollLogoRef}
        >
          <img src={logo1} />
          <img src={logo1} />
        </Flex>
        <Flex
          align="center"
          className={styles.p4_scroll_box_inner}
          ref={scrollLogoRef1}
        >
          <img src={logo2} />
          <img src={logo2} />
        </Flex>
        <Flex
          align="center"
          className={styles.p4_scroll_box_inner}
          ref={scrollLogoRef2}
        >
          <img src={logo3} />
          <img src={logo3} />
        </Flex>
        <Flex
          align="center"
          className={styles.p4_scroll_box_inner}
          ref={scrollLogoRef3}
        >
          <img src={logo4} />
          <img src={logo4} />
        </Flex>
      </div>
      <div className={styles.p4_p5_line}></div>
      <div className={styles.p5}>
        <div className={styles.p5_inner}>
          <div className={styles.p5_title}>
            <div className={styles.p5_title_text}>近期焦点</div>
            <Flex
              align="center"
              gap={8}
              className={styles.p5_more}
              onClick={() => {
                navigate("/news");
                // window.location.href = "/news";
              }}
              onMouseEnter={playLottieOnce1}
              onMouseLeave={stopLottie1}
            >
              MORE
              <Lottie {...lottieOptions1} />
            </Flex>
          </div>
          <div className={styles.p5_list}>
            <FocusList />
          </div>
        </div>
      </div>
      <div className={styles.p6}>
        <div className={styles.p6_inner}>
          <div className={styles.p6_title}>
            生态伙伴
            <Flex
              align="center"
              gap={8}
              className={styles.p6_more}
              onClick={() => {
                navigate("/cooperation");
                // window.location.href = "/cooperation";
              }}
              onMouseEnter={playLottieOnce2}
              onMouseLeave={stopLottie2}
            >
              MORE
              <Lottie {...lottieOptions2} />
            </Flex>
          </div>
          <div className={styles.p6_list}>
            <PartnerList />
          </div>
        </div>
      </div>
      <div className={styles.p7}>
        <div className={styles.p7_inner}>
          <div className={styles.p7_title}>
            <span>AI数字员工</span>已广泛活跃于众多行业及企业场景中
            <br />
            以下来自客户的分享：
          </div>
          <div className={styles.p7_human_list}>
            <HumanList />
          </div>
        </div>
      </div>
    </div>
  );
};
export default isMobile() ? MobileHome : Home;
